import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 7AEF7097-EC88-4D09-A65E-5244DDA99599
 * name netflix
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/netflix.svg
 * tags
 * - Brand / Logo 
 */
export const NetflixIcon = createSvgIcon(<><path d="M6.5,2H10.5L13.44,10.83L13.5,2H17.5V22C16.25,21.78 14.87,21.64 13.41,21.58L10.5,13L10.43,21.59C9.03,21.65 7.7,21.79 6.5,22V2Z" /></>, 'NetflixIcon');
export default NetflixIcon